import axios from "@/plugins/axios-setting";
import { DurationTypeInterface } from "@/types/durationType.type";
export function getDurationTypes(): Promise<DurationTypeInterface[]> {
  return axios.get("/api/duration-type/");
}

export function getDurationTypeById(id: number): Promise<DurationTypeInterface> {
  return axios.get(`/api/duration-type/${id}/`);
}
